/* eslint-disable func-style, no-undef */
require('../emile.min.js');

const checkAddrSwitch = function checkAddrSwitch(ev) {
  if (!ev) {
    ev = false;
  }
  const secondaryAddress = $('#secondaryAddress');
  if (!secondaryAddress.length) {
    return;
  }

  if ($('#newAddress').prop('checked')) {
    secondaryAddress.show();
    emile($('#secondaryAddress')[0], 'opacity:1', { duration: 150 });
    if (ev === true) { window.scrollTo(0, ($('#secondaryAddress').offset().top - 20)); }
  } else {
    $('#secondaryAddress').hide().css({ opacity: 0 });
  }

  $('#switchAddress input:radio').each(function callback() {
    $(this).click(() => {
      DR.checkAddrSwitch(true);
    });
  });
};

module.exports = checkAddrSwitch;
